type SortBy = "name" | "email" | "status" | "joined" | "num" | "position" | null | undefined;

interface SortableItem {
  name?: string;
  email?: string;
  disabled?: number;
  joinedAt?: string;
  id?: string;
  priority?: number;
}

const filterBySortBy = <T extends SortableItem>(
  sortBy: SortBy,
  data: T[],
  reverseSort?: boolean
): T[] => {
  if (!sortBy) return data
  let compareFunction: (a: T, b: T) => number

  switch (sortBy) {
    case "name":
      compareFunction = (a, b) => (a.name || '').localeCompare(b.name || '')
      break
    case "email":
      compareFunction = (a, b) => (a.email || '').localeCompare(b.email || '')
      break
    case "status":
      compareFunction = (a, b) => (a.disabled || 0) - (b.disabled || 0)
      break
    case "joined":
      compareFunction = (a, b) => {
        const dateA = new Date(a.joinedAt || 0)
        const dateB = new Date(b.joinedAt || 0)
        return dateA.getTime() - dateB.getTime()
      }
      break
    case "num":
      compareFunction = (a, b) => {
        // Use localeCompare with numeric option for IDs like "GBM-0001"
        return (a.id || '').localeCompare(b.id || '', undefined, { numeric: true });
      }
      break
    case "position":
      compareFunction = (a, b) => (a.priority || 0) - (b.priority || 0)
      break
    default:
      return data
  }

  return [...data].sort((a, b) =>
    reverseSort ? compareFunction(b, a) : compareFunction(a, b)
  )
}

export default filterBySortBy